import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { formatISO, isValid } from 'date-fns';

import RadixDialog from '../../../../shared/RadixDialog';
import TextInput from '../../../../shared/FormStyles/TextInput.jsx';
import Text from '../../../../shared/Text';

import { formatTime, parseDate } from '../../utils/helpers';
import { REMINDER } from '../../utils/constants';

import { ChangeDate } from './ChangeDate.jsx';

import { useGetCampaignDates } from '../../hooks/useFetchCampaign';

export const ReminderDateInput = ({
  reminderDate,
  changeReminderDate,
  campaignId,
  reminderSendHour,
  postDate,
  maxReminderDate,
  reminderSent,
}) => {
  const { t } = useTranslation('posts');
  const [dateModalOpen, setDateModalOpen] = useState(false);
  const isPostDateSet = Boolean(postDate);
  const { boardTimezone } = useGetCampaignDates({ campaignId });

  const inputValue = reminderDate
    ? `${parseDate(reminderDate, '')} at ${formatTime({
        hour: reminderSendHour,
        timezone: boardTimezone,
      })}`
    : t('reviewModal.messageForm.unsetPostReminderDateMessage');

  return (
    <Wrapper>
      <Text variant="subtitle2" color="black.60">
        {t('reviewModal.messageForm.reminderDate')}
      </Text>
      <TextInput
        value={inputValue}
        disabled={!isPostDateSet || reminderSent}
        disabledVariant="whiteBg"
        placeholder={t('reviewModal.messageForm.reminderPlaceholder')}
        onClick={() => setDateModalOpen(true)}
      />
      <CalendarIcon />
      <RadixDialog
        isOpen={dateModalOpen}
        onClose={() => setDateModalOpen(false)}
        title={t('reviewModal.messageForm.reminderDate')}
      >
        <ChangeDate
          origin={REMINDER}
          maxReminderDate={maxReminderDate}
          postDate={postDate}
          postSendHour={reminderSendHour}
          publishDate={reminderDate}
          campaignId={campaignId}
          label={t('reviewModal.messageForm.reminderLabel')}
          handleCancel={() => setDateModalOpen(false)}
          handleSave={({ publishDate, sendHour }) => {
            const parsedDate = isValid(publishDate)
              ? formatISO(publishDate, { representation: 'date' })
              : publishDate;

            changeReminderDate({
              publishDate: parsedDate,
              sendHour,
            });
            setDateModalOpen(false);
          }}
        />
      </RadixDialog>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  margin-bottom: 24px;
  position: relative;
`;

const CalendarIcon = styled.i.attrs({
  className: 'fa-regular fa-calendar',
})`
  position: absolute;
  top: 38px;
  right: 10px;
`;
